import React, { useContext } from 'react';
import t from '@/utils/Language/PrintButton-translations';
import Button from '@/components/Button/Button';
import { modalContext } from '@/context/modal.context';
import { AccountContext } from '@/context/account.context';
import { viewportContext } from '@/context/viewport.context';

const PrintButton = ({ resource, buttonType, buttonShape, buttonBorder, hideOnMobile }) => {
  const { enqueueModal } = useContext(modalContext);
  const account = useContext(AccountContext);
  const { unusedIsPhone, unusedIsXSPhone } = useContext(viewportContext);

  const startPrintProcess = (e) => {
    if (!account.state.isLoggedIn) {
      return enqueueModal({ name: 'SignupModal', reason: 'print' }, { forceOpen: true });
    }

    enqueueModal({
      name: 'PrintModal',
      title: t('Generating PDF...'),
      is_referral: false,
      resources: [resource]
    });
  };

  return (
    <Button
      type={buttonType || 'default'}
      border={buttonBorder || false}
      shape={buttonShape || 'pill'}
      text={t('Print')}
      icon={{ style: 'fas', font: 'print' }}
      styles={{ hidden: (unusedIsPhone || unusedIsXSPhone) && hideOnMobile }}
      onButtonClick={startPrintProcess}
    />
  );
};

export default PrintButton;
